import React, { useEffect, useMemo, useRef, useState } from "react";
import PageTable from "@/components/i-pageTable/i-pageTable";
import PageTab from "@/components/i-pageTab/i-pageTab";

import {
  getuserWithdrawList,
  shoppingOrderExport,
  getRewardDetail,
  getDeviceCount,
  deleteUserWithdraw,
  getUserCardDetail,
  modifyUserCard,
} from "@/api/shopping";

import { Button, message, Modal, Space, Tag, Image } from "antd";
import {
  downloadFile,
  getFirstDay,
  getTimeFormat,
  resetForm,
  setIcons,
} from "@/utils/common";

import { useSelector, useDispatch, useStore } from "react-redux";
import { dictInfoAsync } from "@/stores/dictInfo";
import { formTab, columns, userEditFormTab } from "./helps";


const OrderManager = () => {
  const dispatch = useDispatch();
  const {
    state: { goods_order_status, express_status, express_company_code },
  } = useSelector((state: { dictInfo: any }) => state.dictInfo);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [sendGoodsOpen, setSendGoodsOpen] = useState(false);
  const [deviceCount, setDeviceCount] = useState(0);
  const [offqybOpen, setOffqybOpen] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [rewardDetailData, setRewardDetailData] = useState<any>({
    rows: [],
    total: 0,
  });
  const [storeInfoList, setStoreInfoList] = useState<
    {
      merId: string;
      merMobile: string;
      merName: string;
      userId: string;
    }[]
  >([]);

  const [pageData, setPageData] = useState<
    SelectCmsShoppingOrderPageRes["rows"]
  >([]);
  const [formData, setFormData] = useState<any>({
    categoryName: "",
    startTime: getTimeFormat(getFirstDay(new Date()), "yyyy-MM-dd HH:mm:ss"),
    endTime: getTimeFormat(new Date(), "yyyy-MM-dd HH:mm:ss"),
    ypageNum: 1,
    ypageSize: 10,
  });

  const [modalFormuserEdit, setModalFormuserEdit] = useState<any>({});

  const [rewardDetailFormData, setRewardDetailFormData] = useState<any>({
    ypageNum: 1,
    ypageSize: 10,
    businessId: "",
  });

  const getDeviceCountData = async () => {
    const res = await getDeviceCount({
      ...formData,
    });
    setDeviceCount(res.data);
  };

  const footer = [
    // {
    //   title: "导出",
    //   icon: setIcons("DownloadOutlined"),
    //   onClick: () => exportExcel(),
    //   loading: exportLoading,
    // },
    // {
    //   render: (
    //     <div style={{ lineHeight: "32px" }}>
    //       <div>总设备数量：{deviceCount}</div>
    //     </div>
    //   ),
    // },
  ];

  useEffect(() => {
    getPageData();
    getDeviceCountData();
  }, [formData]);

  useEffect(() => {
    !goods_order_status && dispatch(dictInfoAsync("goods_order_status") as any);
    !express_status && dispatch(dictInfoAsync("express_status") as any);
    !express_company_code &&
      dispatch(dictInfoAsync("express_company_code") as any);
  }, []);

  useEffect(() => {
    if (rewardDetailFormData.businessId) {
      getModalData();
    }
  }, [rewardDetailFormData]);

  const getPageData = async () => {
    setLoading(true);
    try {
      const data = await getuserWithdrawList(formData);
      setPageData(data.rows);
      setTotal(data.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const search = (val: any) => {
    setFormData({ ...formData, ...val, ypageNum: 1 });
  };
  const pageChange = (current: number, pageSize: number) => {
    setFormData({
      ...formData,
      ypageNum: current,
      ypageSize: pageSize,
    });
  };

  const exportExcel = async () => {
    setExportLoading(true);
    try {
      const data = await shoppingOrderExport(formData);
      downloadFile(
        data as any,
        "商城订单统计" + getTimeFormat(new Date(), "yyyy-MM-dd HH:mm:ss")
      );
    } catch (error) {
    } finally {
      setExportLoading(false);
    }
  };

  const setOrderDollar = async (val: string) => {
    setRewardDetailFormData({
      ...rewardDetailFormData,
      businessId: val,
      businessOrderType: "1",
    });
    setOffqybOpen(true);
  };

  const getModalData = async () => {
    try {
      const data: any = await getRewardDetail(rewardDetailFormData);
      setRewardDetailData({
        rows: data.rows,
        total: data.total,
      });
    } catch (error) {}
  };

  const reset = () => {
    setFormData({
      ...resetForm(formData),
      dateType: 0,
      startTime: getTimeFormat(getFirstDay(new Date()), "yyyy-MM-dd HH:mm:ss"),
      endTime: getTimeFormat(new Date(), "yyyy-MM-dd HH:mm:ss"),
    });
  };

  const rewardDetailClose = () => {
    setOffqybOpen(false);
    setModalFormuserEdit({});
  };

  const deleteWithdraw = async (val: string) => {
    try {
      Modal.confirm({
        title: "系统提示",
        content: "确定删除该用户提现方式吗",
        onOk: async () => {
          await deleteUserWithdraw(val);
          message.success("删除成功");
          getPageData();
        },
      });
    } catch (error) {}
  };

  const confirmUserEdit = async (val: any) => {
    console.log(val, "valvalval");
    try {
      await modifyUserCard(val);
      message.success("编辑成功");
      rewardDetailClose();
      getPageData();
    } catch (error) {}
  };

  const editWithdraw = async (val: any) => {
    try {
      const {data} = await getUserCardDetail(val.id);
      setModalFormuserEdit(data);
      setOffqybOpen(true);
    } catch (error) {}
  };

  return (
    <div>
      <Modal
        destroyOnHidden
        open={offqybOpen}
        title="编辑支付信息"
        width="400px"
        footer={<></>}
        onCancel={rewardDetailClose}
      >
       <PageTab
          subFoot
          search={confirmUserEdit}
          reset={rewardDetailClose}
          formTab={userEditFormTab}
          initialValues={modalFormuserEdit}
        ></PageTab>
      </Modal>
      <PageTab
        defaultTimer={[formData.startTime, formData.endTime]}
        reset={reset}
        search={search}
        formTab={formTab}
        footer={[]}
      ></PageTab>
      <PageTable
        loading={loading}
        rowKey="id"
        pageChange={pageChange}
        data={pageData}
        columns={columns(editWithdraw, deleteWithdraw)}
        pagination={{
          total: total,
          current: formData.ypageNum,
        }}
      ></PageTable>
    </div>
  );
};

export default OrderManager;
